<template>
  <div class="gx-msg">
    <top-banner :show-notification="false" @logo="goHome" >
      <template #center>
        <button class="back-btn" @click="$router.back()"><i class="el-icon-arrow-left"></i>返回工作台</button>
      </template>
    </top-banner>
    <div class="gx-msg__box">
      <div class="gx-msg__head">
        <h1 class="gx-msg__title">消息中心</h1>

        <div class="gx-msg__ws" :class="'gx-msg__ws--' + wsState">
          <span class="gx-msg__ws-dot"></span>
          {{ wsText }}
          <span v-if="unread > 0" class="gx-msg__ws-count">{{ unread }}</span>
        </div>
        <div class="gx-msg__spacer"></div>
        <button class="gx-msg__btn" @click="markAllRead">全部标为已读</button>
        <button class="gx-msg__btn gx-msg__btn--danger" @click="clearAll">清空所有</button>
      </div>

      <!-- 类型 tabs -->
      <div class="gx-msg__tabs">
        <button
          v-for="t in typeTabs"
          :key="t.label"
          class="gx-msg__tab"
          :class="{ 'gx-msg__tab--on': typeTab === t.label }"
          @click="typeTab = t.label"
        >
          {{ t.label }}
          <span v-if="t.count > 0" class="gx-msg__tab-count" >{{ t.count }}</span>
        </button>
      </div>

      <!-- 已读筛选 -->
      <div class="gx-msg__read-filter">
        <button
          v-for="s in ['全部', '未读', '已读']"
          :key="s"
          class="gx-msg__filter-btn"
          :class="{ 'gx-msg__filter-btn--on': readTab === s }"
          @click="readTab = s"
        >{{ s }}</button>
      </div>

      <!-- 消息列表 -->
      <div v-if="!filtered.length" class="gx-msg__empty">
        <div class="gx-msg__empty-icon">🔔</div>
        <div class="gx-msg__empty-text">暂无消息</div>
        <div class="gx-msg__empty-sub">实时通知将在这里展示</div>
      </div>

      <div v-else class="gx-msg__list">
        <div
          v-for="m in filtered"
          :key="m.id"
          class="gx-msg__item"
          :class="{ 'gx-msg__item--unread': !m.isRead }"
        >
          <span class="gx-msg__item-dot"></span>
          <div class="gx-msg__item-icon">🔔</div>
          <div class="gx-msg__item-body">
            <div class="gx-msg__item-top">
              <span class="gx-msg__type" :style="typeStyle(m.type)">{{ typeLabel(m.type) }}</span>
              <span class="gx-msg__item-title">{{ m.title || '通知' }}</span>
            </div>
            <p class="gx-msg__item-content" :style="{ color: m.isRead ? '#6A6A8A' : '#4A4A6A' }">{{ m.content || m.message }}</p>
            <span class="gx-msg__item-time">{{ formatTime(m.created_at || m.create_time) }}</span>
          </div>
          <div class="gx-msg__item-ops">
            <button v-if="m.type === 'import_progress'" class="gx-msg__btn gx-msg__btn--sm" @click="viewDetail(m)">查看详情</button>
            <button v-if="!m.isRead" class="gx-msg__btn gx-msg__btn--sm" @click="markRead(m)">标为已读</button>
            <button class="gx-msg__btn gx-msg__btn--sm gx-msg__btn--danger" @click="delMsg(m)">删除</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TopBanner from "@/components/newUi/TopBanner.vue";

export default {
  name: 'NewMessagesPage',
  components: {TopBanner},
  data() {
    return {
      msgs: [],
      typeTab: '全部',
      readTab: '全部',
      _unwatch: null
    }
  },
  computed: {
    wsState() {
      return this.$store.state.notification.wsState
    },
    wsText() {
      const map = {
        connected: '实时通知已连接',
        connecting: '连接中...',
        reconnecting: '重连中...',
        disconnected: '未连接',
        failed: '连接失败'
      }
      return map[this.wsState] || '未知状态'
    },
    unread() {
      return this.msgs.filter((m) => !m.isRead).length
    },
    typeTabs() {
      return [
        { label: '全部', count: this.msgs.length },
        { label: '导入进度', count: this.msgs.filter((m) => m.type === 'import_progress').length },
        { label: '系统消息', count: this.msgs.filter((m) => m.type === 'system').length },
        { label: '任务通知', count: this.msgs.filter((m) => m.type === 'task').length }
      ]
    },
    filtered() {
      let list = this.msgs
      if (this.typeTab !== '全部') list = list.filter((m) => m.type === this.typeTab)
      if (this.readTab === '未读') list = list.filter((m) => !m.isRead)
      if (this.readTab === '已读') list = list.filter((m) => m.isRead)
      return list
    }
  },
  created() {
    this.$store.dispatch('notification/initNotificationWS')
    this.msgs = (this.$store.state.notification.notifications || []).slice()
    this._unwatch = this.$store.watch(
      (state) => state.notification.notifications,
      (val) => {
        const existing = new Set(this.msgs.map((m) => m.id))
        ;(val || []).forEach((n) => {
          if (!existing.has(n.id)) this.msgs.unshift(n)
        })
      }
    )
  },
  beforeDestroy() {
    if (this._unwatch) this._unwatch()
  },
  methods: {
    ...mapActions({
      markAllAsReadStore: 'notification/markAllAsRead'
    }),
    goHome() {
      this.$router.push('/')
    },
    typeLabel(type) {
      const map = { import_progress: '导入进度', system: '系统消息', task: '任务通知' }
      return map[type] || '通知'
    },
    typeStyle(type) {
      const map = {
        'system': ['#D4A946', 'rgba(212,169,70,.1)', 'rgba(212,169,70,.3)'],
        'import_progress': ['#3FB6E0', 'rgba(63,182,224,.1)', 'rgba(63,182,224,.3)'],
        'task': ['#4ADE80', 'rgba(74,222,128,.1)', 'rgba(74,222,128,.3)']
      }
      const [color, bg, border] = map[type] || ['#4A4A6A', 'rgba(139,157,195,.1)', 'rgba(139,157,195,.25)']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    formatTime(timeStr) {
      if (!timeStr) return ''
      let time
      if (typeof timeStr === 'number') time = new Date(timeStr < 10000000000 ? timeStr * 1000 : timeStr)
      else time = new Date(timeStr)
      if (isNaN(time.getTime()) || time.getFullYear() < 2000) return ''
      const now = new Date()
      const diff = now - time
      if (diff < 0) return '刚刚'
      if (diff < 60 * 1000) return '刚刚'
      if (diff < 60 * 60 * 1000) return Math.floor(diff / (60 * 1000)) + '分钟前'
      if (diff < 24 * 60 * 60 * 1000) return Math.floor(diff / (60 * 60 * 1000)) + '小时前'
      if (diff < 7 * 24 * 60 * 60 * 1000) return Math.floor(diff / (24 * 60 * 60 * 1000)) + '天前'
      const pad = (n) => String(n).padStart(2, '0')
      return `${time.getFullYear()}-${pad(time.getMonth() + 1)}-${pad(time.getDate())} ${pad(time.getHours())}:${pad(time.getMinutes())}`
    },
    markRead(m) {
      m.isRead = true
    },
    markAllRead() {
      this.msgs.forEach((m) => { m.isRead = true })
      this.markAllAsReadStore()
      this.$message.success('已全部标为已读')
    },
    delMsg(m) {
      const idx = this.msgs.indexOf(m)
      if (idx > -1) this.msgs.splice(idx, 1)
    },
    clearAll() {
      this.msgs = []
      this.$message.success('已清空')
    },
    viewDetail(m) {
      this.$router.push('/uc_product?menuId=131')
    }
  }
}
</script>

<style scoped>
.gx-msg {
  min-height: 100vh;
  background: rgb(240, 242, 248);
  font-family: 'Noto Sans SC', sans-serif;
}
.back-btn{
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  padding: 7px 14px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(255, 255, 255);
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 auto;
}
.gx-msg__box{
  padding: 22px 28px;
  max-width: 1100px;
  margin: 0 auto;
}
.gx-msg__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.gx-msg__title {
  font-family: "Noto Serif SC", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--gx-black);
  margin: 0;
}
.gx-msg__ws {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
}
.gx-msg__ws-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  box-shadow: 0 0 6px currentColor;
}
.gx-msg__ws--connected {
  background: rgba(74, 222, 128, .08);
  border: 1px solid rgba(74, 222, 128, .25);
  color: #4ADE80;
}
.gx-msg__ws--failed {
  background: rgba(248, 113, 113, .08);
  border: 1px solid rgba(248, 113, 113, .25);
  color: #F87171;
}
.gx-msg__ws--disconnected {
  background: rgba(139, 157, 195, .08);
  border: 1px solid rgba(139, 157, 195, .25);
  color: #6A6A8A;
}
.gx-msg__ws-count {
  padding: 0 6px;
  border-radius: 8px;
  background: #F87171;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
}
.gx-msg__spacer {
  flex: 1;
}
.gx-msg__btn {
  height: 32px;
  padding: 0px 14px;
  border-radius: 7px;
  border: 1px solid rgb(224, 224, 236);
  background: rgb(255, 255, 255);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgb(74, 74, 106);
  cursor: pointer;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}
.gx-msg__btn:hover{
  border-color: var(--gx-gold);
  color: var(--gx-gold);
}
.gx-msg__btn--danger {
  color: var(--gx-red);
  border-color: var(--gx-red);
}
.gx-msg__btn--danger:hover{
  color: #ffffff;
  background: var(--gx-red);
}
.gx-msg__btn--sm{
  height: 30px;
  font-size: 12px;
}
.gx-msg__tabs {
  display: flex;
  border-bottom: 2px solid rgb(224, 224, 236);
  margin-bottom: 18px;
  animation: 0.5s ease-out 0.05s 1 normal both running msgIn;
  position: relative;
}
.gx-msg__tab {
  height: 38px;
  padding: 0 18px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  background: transparent;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgb(74, 74, 106);
  margin-bottom: -2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
}
.gx-msg__tab--on {
  font-weight: 700;
  color:var(--gx-gold);
  border-color: var(--gx-gold);
}
.gx-msg__tab-count {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: var(--gx-gold);
  font-family: "JetBrains Mono", monospace;
  font-size: 9px;
  font-weight: 700;
  color: var(--gx-black);
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-msg__tab-count--on {
  background: rgba(200, 68, 60, .15);
  color: #C8443C;
}

.gx-msg__read-filter {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
}
.gx-msg__filter-btn {
  height: 28px;
  padding: 0 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  color: #4A4A6A;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-msg__filter-btn--on {
  background: #E1E5EE;
  border-color: rgba(212, 169, 70, .45);
  color: #E8C778;
}
.gx-msg__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-msg__item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 8px;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(224, 224, 236);
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 8px;
  cursor: pointer;
  position: relative;
  animation: 0.4s ease-out 0.12s 1 normal both running msgIn;
  transition: border 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.gx-msg__item:hover{
  background: rgb(245,240,232);
  border-color: var(--gx-gold);
  box-shadow:none
}
.gx-msg__item--unread {
  background: rgb(255, 251, 242);
  border: 2px solid rgba(212, 169, 70, 0.25);
}

.gx-msg__item-icon{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(63, 182, 224, 0.08);
  border: 1.5px solid rgba(63, 182, 224, 0.208);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.gx-msg__item-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background:transparent;
  flex-shrink: 0;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.gx-msg__item-body{
  flex: 1;
}
.gx-msg__item-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.gx-msg__type {
  padding: 1px 8px;
  border-radius: 8px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 600;
}
.gx-msg__item-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--gx-black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-msg__item--unread .gx-msg__item-dot{
  background:var(--gx-gold);
  box-shadow: rgb(212, 169, 70) 0px 0px 6px;
}
.gx-msg__item--unread .gx-msg__item-title{
  font-weight: 700;
}
.gx-msg__item-time {
  font-family: Inter, monospace;
  font-size: 11px;
  color: rgb(106, 106, 138);
  margin-top: 4px;
}
.gx-msg__item-content {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(74, 74, 106);
 /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;*/
}
.gx-msg__item-ops {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.gx-msg__empty {
  padding: 56px 0;
  text-align: center;
  border-radius: 12px;
  background: #F7F8FA;
  border: 1px solid rgba(212, 169, 70, .1);
}
.gx-msg__empty-icon {
  font-size: 40px;
  margin-bottom: 10px;
}
.gx-msg__empty-text {
  font-size: 14px;
  color: #4A4A6A;
  font-weight: 500;
}
.gx-msg__empty-sub {
  font-size: 12px;
  color: #6A6A8A;
  margin-top: 4px;
}
</style>
